import keyMirror from 'keymirror'

export default keyMirror({
  GET_PERS_REQUEST: null,
  GET_PERS_SUCCESS: null,
  GET_PERS_FAILED: null,

  ADD_PER_REQUEST: null,
  ADD_PER_SUCCESS: null,
  ADD_PER_FAILED: null,

  GET_PER_DETAIL_REQUEST: null,
  GET_PER_DETAIL_SUCCESS: null,
  GET_PER_DETAIL_FAILED: null,

  GET_PER_CURRENT_DATA_REQUEST: null,
  GET_PER_CURRENT_DATA_SUCCESS: null,
  GET_PER_CURRENT_DATA_FAILED: null,

  UPDATE_PER_REQUEST: null,
  UPDATE_PER_SUCCESS: null,
  UPDATE_PER_FAILED: null,

  DELETE_PER_REQUEST: null,
  DELETE_PER_SUCCESS: null,
  DELETE_PER_FAILED: null,

  UPDATE_FILTER_PER_SUCCESS: null,

  GET_SYSTEM_PERS_REQUEST: null,
  GET_SYSTEM_PERS_SUCCESS: null,
  GET_SYSTEM_PERS_FAILED: null,

  GET_PER_ALERTS_REQUEST: null,
  GET_PER_ALERTS_SUCCESS: null,
  GET_PER_ALERTS_FAILED: null,

  GET_VEHICLE_TRIPS_REQUEST: null,
  GET_VEHICLE_TRIPS_SUCCESS: null,
  GET_VEHICLE_TRIPS_FAILED: null,

  GET_VEHICLE_TRIP_DETAIL_REQUEST: null,
  GET_VEHICLE_TRIP_DETAIL_SUCCESS: null,
  GET_VEHICLE_TRIP_DETAIL_FAILED: null,

  PUBLISH_IOT_SERVICE_REQUEST: null,
  PUBLISH_IOT_SERVICE_SUCCESS: null,
  PUBLISH_IOT_SERVICE_FAILED: null,

  GET_PER_PACKAGE_LOGS_REQUEST: null,
  GET_PER_PACKAGE_LOGS_SUCCESS: null,
  GET_PER_PACKAGE_LOGS_FAILED: null,

  EXPORT_VEHICLE_TRIP_DETAIL_REQUEST: null,
  EXPORT_VEHICLE_TRIP_DETAIL_SUCCESS: null,
  EXPORT_VEHICLE_TRIP_DETAIL_FAILED: null,

  GET_COMPANY_PERS_LINKED_REQUEST: null,
  GET_COMPANY_PERS_LINKED_SUCCESS: null,
  GET_COMPANY_PERS_LINKED_FAILED: null,

  GET_PERS_KIT_CONFIGURATION_REQUEST: null,
  GET_PERS_KIT_CONFIGURATION_SUCCESS: null,
  GET_PERS_KIT_CONFIGURATION_FAILED: null,

  GET_MQTT_MESSAGE_LOGS_REQUEST: null,
  GET_MQTT_MESSAGE_LOGS_SUCCESS: null,
  GET_MQTT_MESSAGE_LOGS_FAILED: null,

  GET_DOWNLOADABLE_FIRMWARE_VERSIONS_REQUEST: null,
  GET_DOWNLOADABLE_FIRMWARE_VERSIONS_SUCCESS: null,
  GET_DOWNLOADABLE_FIRMWARE_VERSIONS_FAILED: null,

  GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_REQUEST: null,
  GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_SUCCESS: null,
  GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_FAILED: null,

  PREPARE_ENCRYPTION_REQUEST: null,
  PREPARE_ENCRYPTION_SUCCESS: null,
  PREPARE_ENCRYPTION_FAILED: null,

  DOWNLOAD_CIPHERED_FIRMWARE_REQUEST: null,
  DOWNLOAD_CIPHERED_FIRMWARE_SUCCESS: null,
  DOWNLOAD_CIPHERED_FIRMWARE_FAILED: null
})
